import React, { useEffect, useCallback, useRef } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useDebouncedCallback = <T extends any[]>(
  callback: (...args: T) => void,
  delay: number,
  dependencies: React.DependencyList
): ((...args: T) => void) => {
  const timeoutHandler = useRef<number>();

  // Whenever the callback is invoked, cancel any existing timeouts and schedule a new one
  const debouncedCallback = useCallback<(...args: T) => void>(
    (...args) => {
      clearTimeout(timeoutHandler.current);
      timeoutHandler.current = window.setTimeout(() => callback(...args), delay);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [callback, delay, ...dependencies]
  );

  // When the component unmounts, make sure the callback is cancelled
  useEffect(() => {
    return () => {
      clearTimeout(timeoutHandler.current);
    };
  }, []);

  return debouncedCallback;
};
